import { StaffMessages } from '../translations-types';

const translations: StaffMessages = {
  title: 'Berichten',
  markRead: 'Markeer als gelezen',
  noMessages: 'Geen berichten',
  completedQuestionnaire: 'heeft afgerond:',
  sentBy: 'Verstuurd door',
};

export default translations;
